<template>
  <div class="informationWrap">
    <h1 class="title">INFORMATION</h1>
    <about/>
  </div>
</template>

<script>

    import About from "./About";

    export default {
        name: "information" ,
        components : {
          About,
        },
        created () {

        },
        mounted () {

        },
        updated () {

        },
        data () {
          return {
            information : {}
          }
        }
    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/Information.vue